<template>
  <div>
    <v-layout justify-center>
          <div class='dok-loader'>
              <div></div>
              <div></div>
              <div></div>
      
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
          </div>


    </v-layout>
    <v-layout justify-center="">
        <span>LOADING..</span>
    </v-layout>
    <!-- <v-row justify="center"> -->
          
    <!-- </v-row> -->
  </div>        
</template>

<script>
export default {
  props: {
    load: {
      type: Boolean,
      default: true
    }
  }
};
</script>


<style scoped>
.dok-loader {
  display: inline-block;
  position: relative;
  width: 159px;
  height: 64px;
}

.dok-loader div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  animation: dok-loader 1.4s infinite;
}

.dok-loader div:nth-child(1) {
  background: #cd0023;
  left: 6px;
  animation-delay: 0.1s;
}

.dok-loader div:nth-child(2) {
  background: #003657;
  left: 26px;
  animation-delay: 0.2s;
}

.dok-loader div:nth-child(3) {
  background: #003657;
  left: 45px;
  animation-delay: 0.3s;
}

.dok-loader div:nth-child(4) {
  background: #003657;
  left: 83px;
  animation-delay: 0.6s;
}

.dok-loader div:nth-child(5) {
  background: #003657;
  left: 102px;
  animation-delay: 0.7s;
}

.dok-loader div:nth-child(6) {
  background: #003657;
  left: 121px;
  animation-delay: 0.8s;
}

.dok-loader div:nth-child(7) {
  background: #003657;
  left: 140px;
  animation-delay: 0.9s;
}

.dok-loader div:nth-child(8) {
  background: white;
  left: 159px;
  animation-delay: 1s;
}

@keyframes dok-loader {
  0% {
    top: 12px;
    height: 54px;
  }
  50%,
  100% {
    top: 24px;
    height: 27px;
  }
}
</style>